import { Button } from '@/components/ui/button';
import React from 'react';

/**
 * Props para o componente ResendButton
 */
interface ResendButtonProps {
  onClick: () => void;
  icon: React.ReactNode;
  text: string;
  className?: string;
}

/**
 * Componente de botão reutilizável para envio de códigos de verificação
 *
 * Este componente é usado para criar botões padronizados para envio de OTP
 * via diferentes canais (WhatsApp, SMS, Email, etc.).
 *
 * @param props - Propriedades do componente
 * @returns Elemento JSX do botão
 */
export const ResendButton: React.FC<ResendButtonProps> = ({
  onClick,
  icon,
  text,
  className = 'w-full border border-primary text-primary bg-white hover:bg-gray-50 flex items-center justify-center gap-3 h-12',
}) => {
  return (
    <Button onClick={onClick} className={className}>
      {icon}
      <span className="font-medium">{text}</span>
    </Button>
  );
};
